








































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { GetCenter } from "@/request/idr";
@Component({})
export default class Dingxing extends Vue {
  @Prop()
  private report: any;
}
